module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"address":"Address","longitude":"Longitude","latitude":"Latitude","created at":"Created at","created by":"Created by"},"de":{"address":"Adresse","longitude":"Longitude","latitude":"Latitude","created at":"angelegt am","created by":"angelegt von"}}')
  delete Component.options._Ctor
}
